import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { useGetApiClient } from '../../../context/apiContext';

import type { SearchLand, SearchLandResponse } from '@lt/api/dist/methods/search/types';
import type { SearchType } from '../types';

interface UseSearchLandProps {
  openNewTab?: boolean;
}

export interface TripsterLand {
  redirectUrl: string;
  searchType: SearchType;
}

interface UseSearchLand {
  setParams: Dispatch<SetStateAction<SearchLand | TripsterLand | undefined>>;
  loading: boolean;
}

export const useSearchLand = ({ openNewTab = false }: UseSearchLandProps): UseSearchLand => {
  const [params, setParams] = useState<SearchLand | TripsterLand>();
  const [loading, setLoading] = useState(false);
  const api = useGetApiClient();

  let newTabReference: WindowProxy | null = null;

  if (openNewTab && !newTabReference) {
    newTabReference = window.open();
  }

  useEffect(() => {
    if (params === undefined) {
      return;
    }

    setLoading(true);

    api
      ?.getSearchLand(params as SearchLand)
      .then((response?: SearchLandResponse) => {
        if (!response) {
          return;
        }

        const { redirect_url } = response;

        if (newTabReference) {
          newTabReference.location.href = redirect_url;
        } else {
          window.location.href = redirect_url;
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params, newTabReference]);

  return { setParams, loading };
};
